import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_MasterServicePlanChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_MasterServicePlanChild' className='file-pdf-document'>
            <div className='file-template'>
            <h3>Children Annual Master Service Plan</h3>
                <p className='w-750'>DATE COMPLETED:
                    <input type='date' id='txtDateComple' name='txtDateComple' className='add-only' /></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>CID#:</span></td>
                        <td className='w-250'><span className='eleHeader'>D.O.B.:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCID' name='txtCID' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtDob' name='txtDob' className='add-only' /></td>

                    </tr>
                </table>

                <h4>Diagnosis</h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>DSM V (ICD 10) Description or Narrative:</span>
                            <input type='text' id='txt_1' name='txt_1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client's Statement of Needs:</span><br />
                    <textarea id='txt_2' name='txt_2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_3' name='txt_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (1):</span>
                    <textarea id='txt_4' name='txt_4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_5' name='txt_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_6' name='txt_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_7' name='txt_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_8' name='txt_8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_9' name='txt_9' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_10' name='txt_10' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (2):</span>
                    <textarea id='txt_11' name='txt_11' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_12' name='txt_12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_13' name='txt_13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_14' name='txt_14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_15' name='txt_15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_16' name='txt_16' className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_17' name='txt_17' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (3):</span>
                    <textarea id='txt_18' name='txt_18' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_19' name='txt_19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_20' name='txt_20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_21' name='txt_21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_22' name='txt_22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_23' name='txt_23' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_243' name='txt_243' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (4):</span>
                    <textarea id='txt_25' name='txt_25' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_26' name='txt_26' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_27' name='txt_27' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_28' name='txt_28' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_29' name='txt_29' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_30' name='txt_30' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_2431' name='txt_2431' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (5):</span>
                    <textarea id='txt_251' name='txt_251' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_261' name='txt_261' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_271' name='txt_271' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_281' name='txt_281' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_291' name='txt_291' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_301' name='txt_301' className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_2432' name='txt_2432' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (6):</span>
                    <textarea id='txt_252' name='txt_252' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_262' name='txt_262' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_272' name='txt_272' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_282' name='txt_282' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_292' name='txt_292' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_302' name='txt_302' className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_2433' name='txt_2433' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (7):</span>
                    <textarea id='txt_253' name='txt_253' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_263' name='txt_263' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_273' name='txt_273' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_283' name='txt_283' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_293' name='txt_293' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_303' name='txt_303' className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txt_2434' name='txt_2434' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal (8):</span>
                    <textarea id='txt_254' name='txt_254' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Life Domain Codes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_264' name='txt_264' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_274' name='txt_274' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_284' name='txt_284' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_294' name='txt_294' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_304' name='txt_304' className='add-only' />
                        </td>
                    </tr>

                </table>
                <h3>Objectives: (Measurable and Strenths Based)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Objective</span></p>
                <table><tr><td className='w-375'>
                    <input type='text' id='txt_30y' name='txt_30y' className='add-only' />
                </td>
                    <td className='w-375'>
                        <input type='text' id='txt_31' name='txt_31' className='add-only' />
                    </td>
                </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txt_32' name='txt_32' className='add-only'></textarea>
                        </td>
                    </tr></table>




                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t' name='txt_32t' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Target Date:</span>
                            <input type='date' id='txt_33' name='txt_33' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Service Provider/Person Responsible</span>
                            <input type='text' id='txt_34' name='txt_34' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Objective</span> </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_40' name='txt_40' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txt_41' name='txt_41' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><textarea id='txt_42' name='txt_42' className='add-only'></textarea>
                        </td>
                    </tr></table>



                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t1' name='txt_32t1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_43' name='txt_43' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_44' name='txt_44' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Objective</span> </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_50' name='txt_50' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txt_51' name='txt_51' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txt_52' name='txt_52' className='add-only'></textarea></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t2' name='txt_32t2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_53' name='txt_53' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_54' name='txt_54' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Objective</span></p>

                <table>
                    <tr>
                        <td className='w-375'><input type='text' id='txt_58' name='txt_58' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txt_59' name='txt_59' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txt_60' name='txt_60' className='add-only'></textarea></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t3' name='txt_32t3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_61' name='txt_61' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_62' name='txt_62' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Objective</span>   </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='text' id='txt_67' name='txt_67' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txt_68' name='txt_68' className='add-only' /></td>
                    </tr>
                    <tr><td className='w-750'><textarea id='txt_69' name='txt_69' className='add-only'></textarea></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t4' name='txt_32t4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_70' name='txt_70' className='add-only'/>
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_71' name='txt_71' className='add-only'/>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective</span></p>

                    <table>
                        <tr><td className='w-375'><input type='text' id='txt_671' name='txt_671' className='add-only'/></td>
                            <td className='w-375'><input type='text' id='txt_681' name='txt_681' className='add-only'/></td>
                        </tr>
                        <tr><td className='w-750'><textarea id='txt_691' name='txt_691' className='add-only'></textarea></td>
                        </tr>
                    </table>
                    
                    <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t41' name='txt_32t41' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_701' name='txt_701' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_711' name='txt_711' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective</span></p>
                    <table>
                        <tr>
                            <td className='w-375'><input type='text' id='txt_672' name='txt_672' className='add-only' /></td>
                            <td className='w-375'><input type='text' id='txt_682' name='txt_682' className='add-only' /></td>
                        </tr>
                        <tr>
                            <td className='w-750'><textarea id='txt_692' name='txt_692' className='add-only'></textarea></td>
                        </tr>
                    </table>
                   
                    <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t42' name='txt_32t42' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_702' name='txt_702' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_712' name='txt_712' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective</span></p>

                    <table>
                        <tr>
                            <td className='w-375'><input type='text' id='txt_673' name='txt_673' className='add-only'/></td>
                            <td className='w-375'><input type='text' id='txt_683' name='txt_683' className='add-only'/></td>
                        </tr>
                        <tr><td className='w-750'><textarea id='txt_693' name='txt_693' className='add-only'></textarea></td>
                        </tr>
                    </table>
                    
                    <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t43' name='txt_32t43' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_703' name='txt_703' className='add-only'/>
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_713' name='txt_713' className='add-only'/>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective</span></p>
                    <table>
                        <tr>
                            <td className='w-375'><input type='text' id='txt_674' name='txt_674' className='add-only'/></td>
                            <td className='w-375'><input type='text' id='txt_684' name='txt_684' className='add-only'/></td>
                        </tr>
                        <tr>
                            <td className='w-750'><textarea id='txt_694' name='txt_694' className='add-only'></textarea></td>
                        </tr>
                    </table>
                    <p className='w-750'>
                    <span className='eleHeader'>Progress since last review:</span>
                    <textarea id='txt_32t44' name='txt_32t44' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_704' name='txt_704' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_714' name='txt_714' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_75' name='txt_75' className='add-only' />
                            <input type='text' id='txt_76' name='txt_76' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id='txt_77' name='txt_77' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_78' name='txt_78' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_79' name='txt_79' className='add-only' />
                            <input type='text' id='txt_79_1' name='txt_79_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id='txt_80' name='txt_80' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_81' name='txt_81' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_82' name='txt_82' className='add-only' />
                            <input type='text' id='txt_83' name='txt_83' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id='txt_84' name='txt_84' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_85' name='txt_85' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_821' name='txt_821' className='add-only' />
                            <input type='text' id='txt_831' name='txt_831' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id='txt_841' name='txt_841' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_851' name='txt_851' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_822' name='txt_822' className='add-only' />
                            <input type='text' id='txt_832' name='txt_832' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id='txt_842' name='txt_842' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_852' name='txt_852' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_823' name='txt_823' className='add-only' />
                            <input type='text' id='txt_833' name='txt_833' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id='txt_843' name='txt_843' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_853' name='txt_853' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_824' name='txt_824' className='add-only' />
                            <input type='text' id='txt_834' name='txt_834' className='add-only' />
                        </td>
                   <td className='w-375'>
                        <span className='eleHeader'>Date Completed:</span>
                        <input type='date' id='txt_844' name='txt_844' className='add-only' />
                    </td></tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments (optional)</span>
                    <textarea id='txt_854' name='txt_854' className='add-only'></textarea>
                </p>


                <h3>Termination Criteria</h3>
                <p className='w-750'><span className='small'>(Please have Legal Guardian and Client initial each item after reviewing criteria)</span></p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_87' name='cb_87' className='add-only' value='1' /> Successful completion of goals and objectives
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_88' name='cb_88' className='add-only' value='1' /> Legal Guardian no longer agrees to services.
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_89' name='cb_89' className='add-only' value='1' /> Administrative discharge (Client moves, receives duplicate services from
                    another agency, adjudication, or etc.)
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='txt_90' name='txt_90' className='add-only' /> Non-Compliance: Please refer to Attendance Procedures.
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date Terminated:</span>
                            <input type='date' id='txt_91' name='txt_91' className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>Methods</h3>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Service Types</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Frequency</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Length of Session</span></td>

                        <td className='w-187'>
                            <span className='eleHeader'>Duration of Treatment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_92' name='cb_92' className='add-only' value='1' /> Assessment/Review
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_93' name='txt_93' className='add-only w-100 custom-add-only' /> X Annually
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_94' name='txt_94' className='add-only w-50 custom-add-only'/> Hours
                            <input type='text' id='txt_94' name='txt_94' className='add-only w-50 custom-add-only'/> Min

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_96' name='txt_96' className='add-only'/>
                        </td>
                    </tr>

                    <tr>
                    <td className='w-187'>
                            <input type='checkbox' id='cb_107' name='cb_107' className='add-only' value='1' /> Case Management/Monitoring
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_108' name='txt_108' className='add-only w-80 custom-add-only'/> X
                            <input type='text' id='txt_108' name='txt_108' className='add-only w-80 custom-add-only'/>
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_99' name='txt_99' className='add-only w-50 custom-add-only' /> Hours
                            <input type='text' id='txt_99' name='txt_99' className='add-only w-50 custom-add-only' /> Min
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_109' name='txt_109' className='add-only' /></td>
                            </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Client/Guardian received copy:</span>
                    <input type='radio' id='rbClient_Yes' name='rbClient' className='add-only' value='1' /> Yes &nbsp;
                    <input type='radio' id='rbClient_No' name='rbClient' className='add-only' value='0' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Review Update Due:</span>
                            <input type='radio' id='rb_103_1' name='rb_103' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_103_2' name='rb_103' className='add-only' value='2' /> No<br />
                            <input type='checkbox' id='cb_103' name='cb_103' className='add-only' value='1' /> Initial
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Review Update Due:</span>
                            <input type='text' id='txt_30x' name='txt_30x' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`This is to certify that the services prescribed and recommended in this service plan are appropriate and medically
                    necessary to meet the recipient’s needs, as defined by the Florida Medicaid Program.`}
                </p>


                
            </div>
        </form>

    )
}











